<template>
    <div class="account-deleted-page">
        <div class="message-card">
            <div class="icon-wrapper">
                <div class="check-icon">✓</div>
            </div>

            <h1 class="title">アカウントの削除が完了しました。</h1>

            <p class="message">
                これまでhubsynchをご利用いただき、誠にありがとうございました。
            </p>

            <div class="button-area">
                <router-link id="top-page-link" to="/" class="home-button">
                    トップページへ
                </router-link>
            </div>
        </div>
    </div>
</template>

<script setup>
// No script needed for now
</script>

<style scoped>
.account-deleted-page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(180deg, #f8fafc 0%, #eef4ff 100%);
    padding: 24px;
    box-sizing: border-box;
}

.message-card {
    width: 100%;
    max-width: 560px;
    background: #ffffff;
    border-radius: 20px;
    padding: 40px 32px;
    box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);
    text-align: center;
}

.icon-wrapper {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}

.check-icon {
    width: 72px;
    height: 72px;
    border-radius: 9999px;
    background: #e8f7ee;
    color: #16a34a;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 36px;
    font-weight: 700;
}

.title {
    margin: 0 0 16px;
    font-size: 28px;
    line-height: 1.5;
    color: #1e293b;
    font-weight: 700;
}

.message {
    margin: 0;
    font-size: 16px;
    line-height: 1.8;
    color: #475569;
}

.button-area {
    margin-top: 32px;
}

.home-button {
    display: inline-block;
    padding: 12px 24px;
    border-radius: 10px;
    background: #2563eb;
    color: #ffffff;
    text-decoration: none;
    font-size: 15px;
    font-weight: 600;
    transition: background 0.2s ease;
}

.home-button:hover {
    background: #1d4ed8;
}

@media (max-width: 640px) {
    .message-card {
        padding: 32px 20px;
        border-radius: 16px;
    }

    .title {
        font-size: 22px;
    }

    .message {
        font-size: 15px;
    }

    .check-icon {
        width: 64px;
        height: 64px;
        font-size: 30px;
    }
}
</style>